/**
 * Hover-to-open for the collection filter and sort dropdowns.
 *
 * The theme opens these panels on click only. This adds pointer driven opening
 * on the horizontal collection bar by writing the native `open` attribute,
 * which keeps every existing behaviour intact:
 *
 *   - `base.css` rotates the caret with `details[open] > summary
 *     .icon-animated > svg`, so the 9x5 chevron flips 180 degrees while the
 *     panel is open and back when it closes.
 *   - `facets.js` still closes the panel after an option is selected.
 *   - `floating-panel.js` still closes it on resize.
 *   - Click and keyboard activation still work: a pointer click on a summary
 *     that hover already opened is cancelled instead of closing the panel, and
 *     keyboard activation (event.detail === 0) keeps the native toggle.
 *
 * The panel lives inside its own <details>, so travelling from the summary into
 * the open panel never leaves the element and the panel stays open.
 *
 * Listeners are delegated from the document so theme editor updates and
 * section rendering cannot leave stale bindings behind.
 */
(function () {
  var BAR = '.site-collection-bar .facets--horizontal';
  var PANEL = BAR + ' details.facets__panel';
  var SUMMARY = BAR + ' .facets__summary';
  var hovered = null;

  function findPanel(node) {
    if (!node || !node.closest) return null;
    return node.closest(PANEL);
  }

  function open(panel) {
    if (!panel.open) {
      panel.open = true;
    }
    hovered = panel;
  }

  function close(panel) {
    if (panel && panel.open) {
      panel.open = false;
    }
    if (panel === hovered) {
      hovered = null;
    }
  }

  // Opening is driven by the native attribute so every theme behaviour that
  // watches `details[open]` keeps working without being duplicated here.
  document.addEventListener('mouseover', function (event) {
    var panel = findPanel(event.target);
    if (!panel || panel === hovered) return;

    // Moving straight from one dropdown into the next one.
    if (hovered) {
      close(hovered);
    }

    open(panel);
  });

  document.addEventListener('mouseout', function (event) {
    var panel = findPanel(event.target);
    if (!panel) return;

    // Movement between descendants of the same panel is not an exit. The panel
    // content is a sibling of the summary, so this covers summary -> options.
    if (event.relatedTarget && panel.contains(event.relatedTarget)) return;

    close(panel);
  });

  // Hover already owns the open state, so a pointer click on the summary would
  // otherwise close the panel the pointer is still resting on. Keyboard
  // activation reports event.detail === 0 and is left to the browser.
  document.addEventListener('click', function (event) {
    if (!event.detail) return;
    if (!event.target || !event.target.closest) return;

    var summary = event.target.closest(SUMMARY);
    if (!summary) return;

    var panel = summary.parentNode;
    if (panel && panel.tagName === 'DETAILS' && panel.open) {
      event.preventDefault();
    }
  });
})();